<div class="caddie network {{networkType}}" #network_container>
  <div class="card network" id="network-card" [ngClass]="{analysis: networkType==='analysis'}">
    <!-- <header class="card-header">
      <p class="card-header-title">Gene-Gene Interaction Network</p>
    </header> -->

    <div class="card-content">


      <!-- START Legend -->
      <div
        class="legend main"
        [ngClass]="{
          'pushed-left':
            explorerData.activeNetwork.selectedMutationCancerType ||
            explorerData.activeNetwork.selectedExpressionCancerType ||
            explorerData.activeNetwork.selectedTissue
        }"
      >
        <table>
          <tr>
            <td><span class="node"></span></td>
            <td>&nbsp;Gene</td>
          </tr>
          <tr *ngIf="networkType === 'analysis' || networkType === 'simpleAnalysis'">
            <td><span class="seed-node"></span></td>
            <td>&nbsp;Seed Gene</td>
          </tr>
          <tr>
            <td><span class="cancer-node"></span></td>
            <td>&nbsp;Cancer Gene</td>
          </tr>
          <tr *ngIf="networkType === 'analysis' || networkType === 'simpleAnalysis'">
            <td><span class="seed-cancer-node"></span></td>
            <td>&nbsp;Seed Cancer Gene</td>
          </tr>
          <tr>
            <td><span class="selected-cancer-node"></span></td>
            <td>&nbsp;Selected Node</td>
          </tr>
          <tr *ngIf="networkType === 'analysis' && target === 'drug' || networkType === 'simpleAnalysis'">
            <td><span class="approved-drug"></span></td>
            <td>&nbsp;Approved Drug</td>
          </tr>
          <tr *ngIf="networkType === 'analysis' && target === 'drug' || networkType === 'simpleAnalysis'">
            <td><span class="non-approved-drug"></span></td>
            <td>&nbsp;Unapproved Drug</td>
          </tr>
          <tr *ngIf="networkType === 'analysis' && target === 'drug' || networkType === 'simpleAnalysis'">
            <td><span class="cancer-drug"></span></td>
            <td
              class="has-tooltip-right"
              data-tooltip="antineoplastic or immunomodulating agent"
            >
              &nbsp;ATC Class L
            </td>
          </tr>
          <tr *ngIf="networkType === 'analysis' && target === 'drug' || networkType === 'simpleAnalysis'">
            <td><span class="cancernet-node">label</span></td>
            <td>&nbsp;Drug in CanceRx</td>
          </tr>
        </table>
      </div>
      <!-- END Legend -->

      <!-- START Gradient Legend -->
      <div
        class="legend gradient analysis-panel main"
        *ngIf="
          explorerData.activeNetwork.selectedMutationCancerType ||
          explorerData.activeNetwork.selectedExpressionCancerType ||
          explorerData.activeNetwork.selectedTissue
        "
      >
        <div class="color-gradient-gene bar"></div>
        <div class="color-gradient-gene-seed bar" *ngIf="networkType === 'analysis' || networkType === 'simpleAnalysis'"></div>
        <div class="color-gradient-cancer-gene bar"></div>
        <div class="color-gradient-cancer-gene-seed bar" *ngIf="networkType === 'analysis' || networkType === 'simpleAnalysis'"></div>
        <span class="annotation-max"
          >High <br />
          <span *ngIf="explorerData.activeNetwork.selectedMutationCancerType"
            >Mutation</span
          >
          <span
            *ngIf="
              explorerData.activeNetwork.selectedExpressionCancerType ||
              explorerData.activeNetwork.selectedTissue
            "
            >Expression</span
          >
        </span>
        <span class="annotation-min"
          >Low <br />
          <span *ngIf="explorerData.activeNetwork.selectedMutationCancerType"
            >Mutation</span
          >
          <span
            *ngIf="
              explorerData.activeNetwork.selectedExpressionCancerType ||
              explorerData.activeNetwork.selectedTissue
            "
            >Expression</span
          >
        </span>
        <div>
          <div class="box-unknown has-background-grey-light"></div>
          <span class="annotation-unknown">Unknown</span>
        </div>
      </div>
      <!-- END Gradient Legend -->

      <!-- START Legend -->
      <!-- <div
        *ngIf="networkType !== 'analysis'"
        class="legend main"
        [ngClass]="{
          'pushed-left':
            explorerData.activeNetwork.selectedMutationCancerType ||
            explorerData.activeNetwork.selectedExpressionCancerType ||
            selectedTissue
        }"
      >
        <table>
          <tr>
            <td><span class="node"></span></td>
            <td>&nbsp;Gene</td>
          </tr>
          <tr>
            <td><span class="cancer-node"></span></td>
            <td>&nbsp;Cancer Gene</td>
          </tr>
          <tr>
            <td><span class="selected-cancer-node"></span></td>
            <td>&nbsp;Selected Node</td>
          </tr>
        </table>
      </div> -->
      <!-- END Legend -->

      <!-- START Gradient Legend -->
      <!-- <div
        class="legend main gradient"
        *ngIf="
          (networkType !== 'analysis' &&
            explorerData.activeNetwork.selectedMutationCancerType) ||
          explorerData.activeNetwork.selectedExpressionCancerType ||
          selectedTissue
        "
      >
        <div class="color-gradient-gene bar"></div>
        <div class="color-gradient-cancer-gene bar"></div>
        <span class="annotation-max"
          >High <br />
          <span *ngIf="explorerData.activeNetwork.selectedMutationCancerType"
            >Mutation</span
          >
          <span *ngIf="selectedExpressionCancerType || selectedTissue"
            >Expression</span
          >
        </span>
        <span class="annotation-min"
          >Low <br />
          <span *ngIf="explorerData.activeNetwork.selectedMutationCancerType"
            >Mutation</span
          >
          <span *ngIf="selectedExpressionCancerType || selectedTissue"
            >Expression</span
          >
        </span>
        <div>
          <div class="box-unknown has-background-grey-light"></div>
          <span class="annotation-unknown">Unknown</span>
        </div>
      </div> -->
      <!-- END Gradient Legend -->

      <div class="card-image" id="canvas-content">
        <div class="parent">
          <div class="network center network-size image1" [ngClass]="{analysis: networkType==='analysis'}" #network></div>
        </div>
      </div>

      <footer class="card-footer toolbar network-footer-container">

        <app-button
        *ngIf="networkType !== 'simpleAnalysis' && networkType !== 'simple'"
        buttonText="Menu"
        (callbackFun)="explorerData.showNetworkMenuDialog = !explorerData.showNetworkMenuDialog"
        icon="fa fa-cogs"
        class="is-inline-block footer-buttons has-tooltip"
        data-tooltip="Opens a menu of the functions 
that revolve around the network."
      >
      </app-button>

      <app-button
      *ngIf="networkType !== 'simpleAnalysis'"
      buttonText="Upload Genes"
      (callbackFun)="explorerData.showCustomGenesDialog = !explorerData.showCustomGenesDialog"
      icon="fa fa-upload"
      class="is-inline-block footer-buttons has-tooltip"
      data-tooltip="Upload a list of genes to the network or to the list of seed genes."
    >
    </app-button>

        <button
          (click)="toCanvas()"
          class="button is-primary has-tooltip is-inline-block footer-buttons"
          data-tooltip="Take a screenshot of the current network"
        > 
          <span class="icon">
            <i class="fas fa-camera" aria-hidden="true"></i>
          </span>
          <span>Screenshot</span>
        </button>

        <app-category-selector
          *ngIf="target === 'drug-target'"
          [expanded]="drugStatusExpanded"
          [selectedElement]="selectedDrugStatus"
          [elements]="analysis.getDrugStatus()"
          (callbackFun)="toggleDrugs($event)"
          label="Drugs"
          class="overlay footer-buttons"
        ></app-category-selector>

        <app-category-selector
          *ngIf="networkType !== 'simpleAnalysis'"
          [expanded]="expressionExpanded"
          [selectedElement]="selectedTissue"
          [elements]="analysis.getTissues()"
          (callbackFun)="selectTissue($event)"
          label="Expr. Tissue"
          class="footer-buttons is-inline-block has-tooltip"
          data-tooltip="Highlight the gene expression in GTEx tissues"
          class="overlay footer-buttons"
        ></app-category-selector>

        <app-category-selector
          *ngIf="networkType !== 'simpleAnalysis'"
          [expanded]="expressionExpanded"
          [selectedElement]="selectedExpressionCancerType"
          (callbackFun)="selectExpressionCancerType($event)"
          [elements]="analysis.getExpressionCancerTypes()"
          label="Expr. Cancer"
          class="footer-buttons is-inline-block has-tooltip"
          data-tooltip="Highlight the gene expression
in TCGA cancer types"
          class="overlay footer-buttons"
        ></app-category-selector>

        <app-category-selector
          *ngIf="networkType !== 'simpleAnalysis'"
          [expanded]="mutationCancerTypesExpanded"
          [selectedElement]="
            explorerData.activeNetwork.selectedMutationCancerType
          "
          [elements]="analysis.getMutationCancerTypes()"
          (callbackFun)="colorMutationGradient($event)"
          label="Mutation"
          class="footer-buttons is-inline-block has-tooltip"
          data-tooltip="Highlight the cancer mutations
in TCGA cancer types"
          class="overlay footer-buttons"
        ></app-category-selector>

        <app-toggle
          class="footer-buttons is-inline-block"
          textOn="Physics On"
          textOff="Off"
          tooltipOn="Enable the network animation."
          tooltipOff="Disable the network animation and freeze nodes."
          [value]="physicsEnabled"
          (valueChange)="updatePhysicsEnabled($event)"
        ></app-toggle>

        <app-button
          *ngIf="networkType === 'basic' && !networkFullscreenStatus"
          buttonText="Fullscreen"
          (callbackFun)="toggleNetworkFullscreen()"
          icon="fas fa-expand-alt"
          class="is-inline-block footer-buttons has-tooltip"
          data-tooltip="Expand the network to fullscreen"
        >
        </app-button>

        <app-button
        *ngIf="networkType === 'basic' && networkFullscreenStatus"
        buttonText="Close Fullscreen"
        (callbackFun)="toggleNetworkFullscreen()"
        icon="fas fa-compress-alt"
        class="is-inline-block footer-buttons has-tooltip"
        data-tooltip="Close the fullscreen"
      >
      </app-button>

      <app-toggle
      textOn="Isolated Nodes On"
      textOff="Off"
      (valueChange)="toggleIsolatedNodes()"
      icon="fas fa-compress-alt"
      class="is-inline-block footer-buttons has-tooltip"
      tooltipOn="Enable visibility of isolated nodes in the network"
      tooltipOff="Disable visibility of isolated nodes in the network"
      [value]="showIsolatedNodes"
    >
    </app-toggle>

        <div class="field" *ngIf="networkType === 'analysis'">
          <p class="control footer-buttons">
            <button class="button is-danger   has-tooltip" data-tooltip="Delete the current analysis."
                    (click)="analysis.removeTask(explorerData.selectedAnalysisToken); explorerData.closeAnalysis()">
              <span class="icon">
                <i class="fas fa-trash" aria-hidden="true"></i>
              </span>
              <span>
                Delete Analysis
              </span>
            </button>
          </p>
        </div>


      </footer>
    </div>
  </div>
</div>
